import { render } from "./Payroll_Employees.vue?vue&type=template&id=157f9356"
import script from "./Payroll_Employees.vue?vue&type=script&lang=js"
export * from "./Payroll_Employees.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__